import { createAsyncThunk } from '@reduxjs/toolkit';
import * as AppConfigService from './app-config-api';

export const getAppConfigs = createAsyncThunk(
    'appConfig/envVars',
    async (_, { rejectWithValue }) => {
        try {
            const response = await AppConfigService.getAppConfigs();
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
